module.exports = __webpack_public_path__ + "img/scroll.99ecb6e7.svg";